import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaChevronCircleLeft, FaChevronCircleRight, FaTimes } from "react-icons/fa";
import "../../Styles/Loginpage/ForgotPassword.css";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    document.title = "Forgot Password | Yellowcalf";
  }, []);

  const handleBackToLogin = () => {
    navigate("/");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
  };

  return (
    <div className="forgot-password-wrapper">
      <div className="fp-card">
        <div className="fp-logo-section">
          <img
            src="/static/media/logo.25ae0241f5bf7d7c5384da9376d392bc.svg"
            alt="edsys logo"
            className="fp-main-logo"
          />
          <p className="fp-subtitle">Education Systems & Solutions</p>
        </div>

        <hr className="fp-divider" />
        
        <div className="fp-content">
          <h2 className="fp-title">Forgot Password?</h2>
          {isSubmitted && (
            <div className="fp-alert-success">
              <div className="fp-alert-text">
                <strong>Well done</strong> we have sent an email to '{email}' with instructions to reset password
              </div>
              <button className="fp-alert-close" onClick={() => setIsSubmitted(false)}>
                <FaTimes />
              </button>
            </div>
          )}

          <p className="fp-instruction">Enter your e-mail address below to reset your password.</p>

          <form onSubmit={handleSubmit}>
            <div className="fp-input-group">
              <span className="fp-input-icon">
                <FaEnvelope />
              </span>
              <input
                type="email"
                className="fp-input-field"
                placeholder=""
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="fp-button-row">
              <button type="button" className="fp-btn-login" onClick={handleBackToLogin}>
                <FaChevronCircleLeft className="fp-icon-btn" /> Log-In
              </button>

              <button type="submit" className="fp-btn-submit">
                Submit <FaChevronCircleRight className="fp-icon-btn" />
              </button>
            </div>
          </form>
        </div>

        <div className="fp-footer">
          <p>2026 © Yellowcalf</p>
        </div>
      </div>
    </div>
  );
}